import React from 'react';

import { Modal } from '@search/vtbeco-ui/src/components/Modal';

import { PriceHistoryPart } from './PriceHistoryPart';
import { PriceHistoryCard } from './PriceHistoryCard';

export function PriceHistoryModal({
    history,
    onClose
}: {
    onClose(): void;
    history: readonly PriceHistoryPart[];
}) {
    return (<Modal
        fullScreen
        showCloseButton
        onRequestClose={() => onClose()}
        title='Цена изменилась'
    >
        {history.map(item =>
            <PriceHistoryCard spaced key={item.date2?.iso ?? ''} item={item} />
        )}
    </Modal>);
}
